module.exports = __webpack_public_path__ + "img/chiang-mai-red-truck-red-ale.d2a06182.png";